import React from "react";
import './privacy.scss';

export default function Privacy() {
    return (
        <div>
            <div className="privacy">
                <div className="company-name">
                    <h1>Globalmetalroyale</h1>
                    <p>Effective Date: March 21, 2023; Last Updated: October 16th, 2023</p>
                </div>

                <div className="applicability">
                    <h1>APPLICABILITY.</h1>
                    <p>This Policy describes how Jane Street treats the personal information we collect from you. If you have offline dealings with us in Europe, for example as a client of Jane Street Financial Limited, please <a>click here</a> to view the applicable privacy policy.</p>
                    <p>By interacting with us, you consent to our privacy practices.</p>
                </div>

                <div className="applicability">
                
                </div>

            </div>
        </div>
    );
}